import React from "react";
import { CalendarDays } from "lucide-react";
import AgendaDayGroup from "./AgendaDayGroup";

function getDateKey(item) {
  const d = item.date || item.start_date || item.visit_date;
  return d?.slice(0, 10) || "sin-fecha";
}

function SkeletonCard() {
  return (
    <div className="flex items-center gap-3 bg-white dark:bg-slate-800 rounded-[24px] border border-slate-100 dark:border-slate-700/60 p-3 animate-pulse overflow-hidden">
      <div className="w-[3px] self-stretch bg-slate-100 dark:bg-slate-700 rounded-full shrink-0" />
      <div className="h-10 w-10 rounded-[12px] bg-slate-100 dark:bg-slate-700 shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="h-3.5 w-3/5 bg-slate-100 dark:bg-slate-700 rounded-full" />
        <div className="h-2.5 w-2/5 bg-slate-50 dark:bg-slate-700/60 rounded-full" />
      </div>
    </div>
  );
}

export default function AgendaTimeline({ items = [], renderItem, emptyMessage = "Sin actividades", emptyAction = null, loading = false }) {
  if (loading) {
    return (
      <div className="space-y-2">
        {[1, 2, 3].map((i) => <SkeletonCard key={i} />)}
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="py-8 flex flex-col items-center gap-3 text-center border border-dashed border-slate-200 dark:border-slate-700/60 rounded-[20px]">
        <div className="h-12 w-12 rounded-[16px] bg-slate-100 dark:bg-slate-800 flex items-center justify-center">
          <CalendarDays size={22} className="text-slate-300 dark:text-slate-600" />
        </div>
        <p className="text-[13px] text-slate-400 dark:text-slate-500 font-medium">{emptyMessage}</p>
        {emptyAction}
      </div>
    );
  }

  // Group sorted items by date key
  const groups = new Map();
  for (const item of items) {
    const key = getDateKey(item);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  }

  const sorted = [...groups.entries()].sort(([a], [b]) => {
    if (a === "sin-fecha") return 1;
    if (b === "sin-fecha") return -1;
    return a.localeCompare(b);
  });

  return (
    <div className="space-y-4">
      {sorted.map(([date, dayItems]) => (
        <AgendaDayGroup key={date} date={date} count={dayItems.length}>
          {dayItems.map((item, i) => renderItem(item, i))}
        </AgendaDayGroup>
      ))}
    </div>
  );
}
